import { Controller } from '../utils/controller';

export default class extends Controller {
  static values = {
    margin: {
      type: String,
      default: '100px'
    }
  };

  static targets = ['source'];
  static requiredTargets = [];
  // TARGETS
  declare sourceTargets: HTMLSourceElement[];

  // VALUES
  declare marginValue: string;

  // STATE
  private observer: IntersectionObserver;

  connect(): void {
    this.observer = new IntersectionObserver(this.onIntersection, {
      rootMargin: this.marginValue
    });
    this.observer.observe(this.element);
  }

  disconnect(): void {
    this.observer.disconnect();
  }

  private onIntersection = (entries: IntersectionObserverEntry[]) => {
    if (entries.find((e) => e.isIntersecting)) {
      if (this.element instanceof HTMLVideoElement) {
        // Load video metadata (poster, duration, etc.)
        this.element.load();
        this.element.dataset.autoplay && this.element.setAttribute('autoplay', 'true');
      }

      this.observer.disconnect();
    }
  };
}
